export const MOBILE_APP_PLATFORM_IOS = 'IOS';
export const MOBILE_APP_PLATFORM_ANDROID = 'ANDROID';
